import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { EmployeeService } from '../../../../../shared/_services/employee.service';
import { Subject } from 'rxjs';
import { UtilService } from '../../../../../shared/_services/util.service';
import { MarketingService } from '../../../../../shared/_services/marketing.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { Location } from '@angular/common';
import { StatusModalComponent } from '../../../../modals/status-modal/status-modal.component';

@Component({
  selector: 'app-exchange-benefits-details',
  templateUrl: './exchange-benefits-details.component.html',
  styleUrls: ['./exchange-benefits-details.component.scss']
})
export class ExchangeBenefitsDetailsComponent implements OnInit {

  exchangeBenefitId: number | string;
  benefitForm: FormGroup;
  employeeTerm$ = new Subject<string>();
  searchedEmployees: any[] = [];
  previousRoute: any;
  exchangeBenefit: any;
  catalogs: any[] = [];
  hotels: any[] = [];
  benefits: any;
  benefitId: boolean = false;
  hotel: boolean = false;
  empCode: boolean = false;
  statusModal: BsModalRef;
  private unsubscribe: Subject<void> = new Subject<void>();
  successMsg: string;
  errorMsg: any;
  isDirty: boolean;
  isSelectedEmployee: boolean = false;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private location: Location,
    private modalService: BsModalService,
    private utilService: UtilService,
    private marketingService: MarketingService,
    private employeeService: EmployeeService
  ) {
    this.modalService.onHide
    .takeUntil(this.unsubscribe)
    .subscribe(res => {
      if (this.statusModal) {
        if (this.statusModal.content.srcObject.action == "action1") {
          if (this.statusModal.content.srcObject.type == "benefit-add") {
            if (this.statusModal.content.srcObject.status || this.statusModal.content.srcObject.status == 0) {
              let status = +this.statusModal.content.srcObject.status;
              // this.activateOrDeactivateBenefit(this.statusModal.content.srcObject.id, status);
            } else {
              this.location.back();
              // this.router.navigate(['/members']);
            }
          }
        }
      }
    })

    this.employeeService.search(this.employeeTerm$)
      .subscribe(res => {
        if (res.error == 0) {
          this.isSelectedEmployee = true;
          this.searchedEmployees = res.responseObj;
          if(this.searchedEmployees && this.searchedEmployees.length && this.searchedEmployees.indexOf(this.benefitForm.get('empCode').value) == -1) {
            this.isSelectedEmployee = true;
          } else {
            if(this.benefitForm.get('empCode').value) {
              this.isSelectedEmployee = true;
            }
          }
        }
      }, err => {
        this.searchedEmployees = [];
      });
  }

  getHotelsByHotelChain() {
    this.employeeService.getHotelsByHotelChain().subscribe(res => {
      if (res.error == 0) {
        this.hotels = res.responseObj;
      }
    }, err => {
      console.error('Error while getting hotel list by hotelchain id: ', err.message);
    })
  }

  getCatalogsList() {
    this.marketingService.getCatalogs("true")
      .subscribe(
        res => {
          if (res.error == 0) {
            this.catalogs = res.responseObj;
          }
          else {
            console.error("get Catalogs :" + res.message);
          }
        },
        err => {
          console.error(err);
        });
  }

  addExchange(isReset) {
    this.employeeService.saveExchangeOfBenefit(this.benefitForm.value).subscribe(res => {
      if(res.error == 0) {
        this.successMsg = !this.exchangeBenefitId ? "Exchange of Benefit has been added successfully" : "Changes made successfully";
        setTimeout(() => {
          this.successMsg = "";
          if (isReset) {
            this.benefitId = false;
            this.hotel = false;
            this.empCode = false;
            this.initForm(null);
          } else {
            this.location.back();
          }
      }, 1500);
      } else {
        this.errorMsg = res && res.message ? res.message : (!this.exchangeBenefitId ? "Error while creating Exchange of Benefit" : "Error while updating Exchange of Benefit");
        setTimeout(() => {
          this.errorMsg = "";
        }, 1500);
      }
    }, err => {
      this.errorMsg = err && err.message ? err.message : (!this.exchangeBenefitId ? "Error while creating Exchange of Benefit" : "Error while updating Exchange of Benefit");
      setTimeout(() => {
        this.errorMsg = "";
      }, 1500);
    })

  }

  getRewardsByHotelChainId() {
    this.marketingService.getRewardsByHotelChainId().subscribe(res => {
      if(res.error == 0) {
        this.benefits = res.responseObj;
      }
    }, err => {
      console.log('Error while getting benefits with catalog Id: ', err.message);
    })
  }

  getHotelsByRewardCatalogId(rewardCatalogId) {
    this.marketingService.getHotelsByRewardCatalogId(rewardCatalogId).subscribe(res => {
      if(res.error == 0) {
        this.hotels = res.responseObj;
      }
    }, err => {
      console.log('Error while getting benefits with catalog Id: ', err.message);
    })
  }

  printVochuer(benefit) {
    this.utilService.printVoucher(benefit, 'print');
  }

  sendVoucher(benefitId) {
    this.employeeService.sendVoucher(benefitId).subscribe(res => {
      if(res.error == 0) {
        this.successMsg = "Voucher sent successfully";
        setTimeout(() => {
          this.successMsg = "";
          this.location.back();
      }, 1500);
      }
    }, err => {
      this.errorMsg = err && err.message ? err.message : "Error while sending Voucher";
      setTimeout(() => {
        this.errorMsg = "";
      }, 1500);
    })
  }

  getBenefitById(benefitId) {
    this.employeeService.getExchangeOfBenefit(benefitId).subscribe(res => {
      if(res.error == 0) {
        this.exchangeBenefit = res.responseObj;
        this.initForm(this.exchangeBenefit);
      }
    },err => {
      console.error('Error while fetching Exchange of Benefit by Id: ', err.message);
    })
  }

  confirmClose() {
    this.statusModal = this.modalService.show(StatusModalComponent, { class: 'confirm-modal' });
    this.statusModal.content.srcObject = {
      mode: 'custom',
      type: 'benefit-add',
      title: 'Confirm',
      message: !this.exchangeBenefitId ? "Are you sure you want to cancel adding a new exchange benefit?" : "Do you want to cancel modifying the exchange benefit?",
      status: null,
      action1: 'Yes',
      action2: 'No',
      action: '',
    }
  }

  goTo(path) {
    this.employeeService.exchangeBenefit = this.benefitForm.value;
    this.router.navigate([path]);
  }


  selectedValue(type, data) {
    if (type == 'hotel') {
      this.benefitForm.get('hotelName').setValue(data && data.hotelName ? data.hotelName : null);
      this.benefitForm.get('hotel').setValue(data && data.hotelId ? data.hotelId : null);
    } else if (type == 'benefit') {
      this.benefitForm.get('benefitName').setValue(data && data.productNameEN ? data.productNameEN : null);
      this.benefitForm.get('benefitId').setValue(data && data.rewardCatalogId ? data.rewardCatalogId : null);
    } else if (type == 'catalog') {
      this.benefitForm.get('catalogName').setValue(data && data.catalogName ? data.catalogName : null);
      this.benefitForm.get('catalogId').setValue(data && data.catalogId ? data.catalogId : null);
    } else if (type == 'employee') {
      if(this.searchedEmployees.length) {
        // this.transactionForm.get('relatedTransactionId').value
        if(this.searchedEmployees.indexOf(data) == -1) {
          this.isSelectedEmployee = true;
        } else {
          this.benefitForm.get('empCode').setValue(data ? data : null);
          this.isSelectedEmployee = false;
        }
      }
    }
  }

  initForm(data?) {
    this.benefitForm = this.fb.group({
      id: [data ? data.id : '', []],
      catalogId: [data ? data.catalogId : null, []],
      catalogName: [data ? data.catalogName : '', []],
      benefitId: [data ? data.benefitId : null, [Validators.required]],
      benefitName: [data ? data.benefitName : '', [Validators.required]],
      hotel: [data ? data.hotel : null, [Validators.required]],
      hotelName: [data ? data.hotelName : '', [Validators.required]],
      empCode: [data ? data.empCode : '', [Validators.required]],
      exchanged: [data ? data.exchanged : false]
    });
    this.benefitForm.controls['benefitId'].valueChanges.subscribe(value => {
      if(value) {
        this.getHotelsByRewardCatalogId(value);
        this.benefitForm.controls['hotel'].setValue(null);
        this.benefitForm.controls['hotelName'].setValue('');
      }
    })
    if(data && data.benefitId) {
      this.getHotelsByRewardCatalogId(data.benefitId);
    }
    this.benefitForm.valueChanges.subscribe(data => {
      if(this.exchangeBenefit && data) {
        if((this.exchangeBenefit.benefitId != data.benefitId) || (this.exchangeBenefit.hotel != data.hotel) || (this.exchangeBenefit.empCode != data.empCode) || (this.exchangeBenefit.exchanged != data.exchanged)) {
          this.isDirty = true;
        } else {
          this.isDirty = false;
        }
      }
    });
  }

  ngOnInit() {
    // this.getHotelsByHotelChain();
    this.getRewardsByHotelChainId();
    this.getCatalogsList();
    this.initForm(null);
    this.previousRoute = this.utilService.getPreviousRoute;
    if(this.previousRoute.indexOf('/hotel/') > -1 || this.previousRoute.indexOf('/rewards-catalog/') > -1) {
      this.exchangeBenefit = this.employeeService.exchangeBenefitDetails;
    } else {
      this.employeeService.exchangeBenefitDetails = null;
      // this.exchangeBenefit = null;
    }
    this.route.params.subscribe(params => {
      this.exchangeBenefitId = +params['id']; // (+) converts string 'id' to a number
      if(this.exchangeBenefitId && !this.exchangeBenefit) {
        this.getBenefitById(this.exchangeBenefitId);
      } else {
        this.initForm(this.exchangeBenefit);
      }
    });
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }


}



// WEBPACK FOOTER //
// ./src/app/components/admin/hca-admin/employees/exchange-benefits-details/exchange-benefits-details.component.ts